module.exports = __webpack_public_path__ + "img/cross.87e2f390.svg";